import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';
import { useMatch, useNavigate, useParams, useSearchParams } from 'react-router';
import { ROUTES } from '../../../constants/RouteNameMapping';
import { DealBoardDealCategory, SelectItem } from '../../../types';
import { DEAL_TYPE_PARAM } from '../constants/dealsSearchParams';
import { dealBoardConfigState } from '../state/DealboardDataState';
import { selectedDealCategoryState, selectedDealTypeState } from '../state/DealboardUIStateJ';

const ITEMS: SelectItem[] = [
  { id: DealBoardDealCategory.CURRENT, value: 'Current Deals' },
  { id: DealBoardDealCategory.PASS, value: 'Passed Deals' },
  { id: DealBoardDealCategory.MISSED, value: 'Missed Deals' },
  { id: DealBoardDealCategory.TRACK, value: 'Tracked Deals' },
  { id: DealBoardDealCategory.CLOSED, value: 'Closed Deals' },
];

export function useSyncFromPath() {
  const [initialized, setInitialized] = useState(false);
  const match = useMatch(`/${ROUTES.DEAL_FLOW}/*`);
  const { dealCategory } = useParams();
  const [search] = useSearchParams();
  const { dealTypes } = useAtomValue(dealBoardConfigState);
  const navigate = useNavigate();
  const setSelectedDealTypeState = useSetAtom(selectedDealTypeState);
  const [selectedDealCategory, setSelectedDealCategory] = useAtom(selectedDealCategoryState);

  useEffect(() => {
    if (!match) {
      return;
    }

    const category = dealCategory;

    const typeId = search.get(DEAL_TYPE_PARAM) ? parseInt(search.get(DEAL_TYPE_PARAM) ?? '') : null;
    const goToType = !typeId ? dealTypes[0].id : typeId;

    if (!category) {
      navigate(`/${ROUTES.DEAL_FLOW}/${ROUTES.DEALS}/${selectedDealCategory.id}`, { replace: true });
    } else {
      setSelectedDealCategory(ITEMS.find((item) => item.id === category) as SelectItem);
      setSelectedDealTypeState(goToType);
    }
    setInitialized(true);
  }, [
    dealCategory,
    dealTypes,
    match,
    navigate,
    search,
    selectedDealCategory.id,
    setSelectedDealCategory,
    setSelectedDealTypeState,
  ]);

  return initialized;
}
